import React from 'react';
import './MobileHeroImage.css';

const MobileHeroImage = () => {
  return (
    <section className="mobile-hero-image">
      <img 
        src="/img/slider_3.jpg" 
        alt="Nintschew & Partner" 
        className="mobile-hero-image__img"
      />
    </section>
  );
};

export default MobileHeroImage;
